/* Tracked lead link: records click, preserves attribution, routes to signup. */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function LeadLink() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [msg, setMsg] = useState("Preparing your MySchoolRx…");

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/api/lead-link/${token}`);
        const d = r.data;
        if (!d.valid) { navigate("/myschoolrx", { replace: true }); return; }
        try {
          sessionStorage.setItem("lead_token", token);
          sessionStorage.setItem("lead_prefill", JSON.stringify(d.prefill || {}));
        } catch { /* ignore */ }
        axios.post(`${API}/api/lead-link/${token}/signup-started`).catch(() => {});
        navigate(`${d.redirect}?lt=${token}`, { replace: true });
      } catch {
        navigate("/myschoolrx", { replace: true });
      }
    })();
  }, [token, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#f9fafb]" data-testid="lead-link-page">
      <div className="text-center">
        <img src="/assets/myschoolrx-wordmark-600.png" alt="MySchoolRx" className="h-10 mx-auto" />
        <p className="mt-4 text-sm text-[#6b7280]">{msg}</p>
      </div>
    </div>
  );
}
